<template>
    <div class="detail_body posi_rela">
        <div class="loading_bd flex_c" v-if="detailLoading">
            <div class="loading_con flex_c">
                <el-icon class="loading_size is-loading">
                    <Loading/>
                </el-icon>
                <div class="loading_text">数据加载中</div>
            </div>
        </div>
        <div class="patient_info_body">
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="detail_font font1_2rem flex_c_left">
                        <span class="no_font">NO.</span><span class="no_num_font">{{ medicalOrder.serialNo }}</span>
                    </div>
                    <div class="detail_font status_font flex_c_right">
                            <span :class="medicalOrder.status === '1' || medicalOrder.status === '6' ? 'text-blue':
                            medicalOrder.status === '2' || medicalOrder.status === '5' ? 'text-orange':
                            medicalOrder.status === '3' || medicalOrder.status === '4' ? 'text-red':'text-grey1'">{{
                                    getOrderStatus(medicalOrder.status)
                                }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="detail_font flex_c_left">
                        <span class="mrr20"><span class="font_gray">姓名：</span>{{ patientInfo.name }}</span>
                        <span class="mrr20"><span
                            class="font_gray">性别：</span>{{ patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知' }}</span>
                        <span class="mrr20"><span
                            class="font_gray">年龄：</span>{{ patientInfo.age === null ? '--' : patientInfo.age }}岁</span>
                        <span class="mrr20"><span
                            class="font_gray">联系电话：</span>{{ patientInfo.phoneNumber === null ? '无' : patientInfo.phoneNumber }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="detail_font50 flex_c_left">
                        <span class="mrr20"><span
                            class="font_gray">身份证号码：</span>{{patientInfo.identity===null?"--":patientInfo.identity.substr(0,6) + '********' + patientInfo.identity.substr(14, 20)}}</span>
                    </div>
                    <div class="detail_font50 flex_c_left">
                        <span class="mrr20"><span
                            class="font_gray">联系地址：</span>{{ patientInfo.province === null ? '无' : patientInfo.province }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="detail_font flex_c_left">
                        <span
                            class="font_gray">临床诊断：</span>{{ medicalOrder.clinicalDiagnosis === null ? '无' : medicalOrder.clinicalDiagnosis }}
                    </div>
                </div>
            </div>
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">RP：
                        <span
                            class="font_gold">{{
                                medicalOrder.billingType === '1' ? '饮片' : medicalOrder.billingType === '2' ? '膏方' : medicalOrder.billingType === '3' ? '水丸' : '颗粒'
                            }}</span>
                    </div>
                </div>
                <div class="detail_info_line">
                    <div class="med_list_con flex_left_warp">
                        <div class="med_list_li flex_c_between" v-for="(item, index) in medicalOrder.orderMedicineList"
                             :key="index">
                            <span class="font_gold"
                                  v-if="item.standard !== null && item.standard !== undefined && item.standard !== '' && (medicalOrder.billingType === '0' || medicalOrder.billingType === 0) && newRuleOpen">[{{
                                    item.standard
                                }}]</span>
                            <span class="med_li_name">{{ item.meName }}</span>
                            <span class="font_gold"
                                  v-if="item.drugProperty && item.drugProperty !== null && item.drugProperty !== undefined && item.drugProperty !== ''">({{
                                    item.drugProperty
                                }})</span>
                            <span class="font_gray"
                                  v-if="item.decoctionId && item.decoctionId !== null && item.decoctionId !== undefined && item.decoctionId !== '' && (medicalOrder.billingType !== '0' && medicalOrder.billingType !== 0) && item.decoctionName !== '无'">({{
                                    item.decoctionName
                                }})</span>
                            <span class="font_gray mrl10">{{ item.newGCount }}g</span>
                        </div>
                    </div>
                </div>
                <div class="detail_info_line flex_t_col"
                     v-if="medicalOrder.billingType === '2' && medicalOrder.orderMedicineFuList.length > 0">
                    <div class="detail_font flex_c_left">辅料：</div>
                    <div class="font_black">{{ showOrderMedicineFuList }}</div>
                </div>
            </div>
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="detail_font flex_c_left">每剂 {{ medicalOrder.orderMedicineList.length }} 味药材，共
                        {{ medicalOrder.viceNum }} 剂
                    </div>
                    <div class="detail_font flex_c_left">
<!--                        <span class="font_gray">药方总重：</span>-->
<!--                        <span-->
<!--                            class="detail_font_red">{{ medicalOrder.orderWeight === null ? '0' : parseFloat(medicalOrder.orderWeight).toFixed(2) }}g</span>-->
                    </div>
                </div>
                <div class="detail_info_line flex_t_col">
                    <div class="detail_font flex_c_top">
                        <div class="f_left font_gray">用法：</div>
                        <div class="f_right">{{ medicalOrder.instructions }}</div>
                    </div>
                    <div class="detail_font flex_c_left"><span
                        class="font_gray">*每次服用袋数请参照随药寄送的贴纸说明</span></div>
                </div>
            </div>
            <!-- 其他信息-->
            <div class="patient_info_bd">
                <div class="detail_info_line flex_c_between">
                    <div class="width100 name_font">其他信息：</div>
                </div>
                <div class="detail_info_line flex_c_top flex_c_wrap">
                    <div class="detail_font50 flex_c_left"><span class="font_gray">开方剂型：</span>
                        {{
                            medicalOrder.billingType === null || medicalOrder.billingType === '0' ? '颗粒' : medicalOrder.billingType === '1' ? '饮片' : medicalOrder.billingType === '2' ? '膏方' : '水丸'
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status !== '1'"><span
                        class="font_gray">开方时间：</span>{{
                            medicalOrder.createTime === null ? "---" : medicalOrder.createTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status !== '1'"><span
                        class="font_gray">接单时间：</span>{{
                            medicalOrder.receiveTime === null ? "---" : medicalOrder.receiveTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '5'"><span
                        class="font_gray">驳回时间：</span>{{
                            medicalOrder.rejectTime === null ? "---" : medicalOrder.rejectTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"
                         v-if="medicalOrder.status === '6' || medicalOrder.status === '7'">
                            <span
                                class="font_gray">支付时间：</span>{{
                            medicalOrder.payTime === null ? "---" : medicalOrder.payTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"
                         v-if="medicalOrder.status === '6' || medicalOrder.status === '7'">
                            <span
                                class="font_gray">发货时间：</span>{{
                            medicalOrder.deliverTime === null ? "---" : medicalOrder.deliverTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '7'">
                            <span
                                class="font_gray">收货时间：</span>{{
                            medicalOrder.completeTime === null ? "---" : medicalOrder.completeTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left" v-if="medicalOrder.status === '8'">
                            <span
                                class="font_gray">取消时间：</span>{{
                            medicalOrder.cancelTime === null ? "---" : medicalOrder.cancelTime
                        }}
                    </div>
                    <div class="detail_font50 flex_c_left"><span
                        class="font_gray">开方备注：</span>{{
                            medicalOrder.remark === '' || medicalOrder.remark === null ? '无' : medicalOrder.remark
                        }}
                    </div>
                </div>
            </div>
        </div>
        <div class="patient_order_detail">
            <div class="detail_info_line flex_c_between">
                <div class="width100 name_font">总费用：<span
                    class="detail_font_red">{{ medicalOrder.orderPrice }}</span><span class="font_gold">元</span>
                </div>
                <div class="flex_c_right">
                    <el-button type="success" v-if="medicalOrder.status === '3'" @click="openPayScreen()">收费</el-button>
                    <el-button :loading="receiptLoading" v-if="medicalOrder.payTime" @click="previewPaymentReceipt">预览凭证</el-button>
                    <el-button type="success" :loading="receiptLoading" v-if="medicalOrder.payTime" @click="printPaymentReceipt">打印凭证</el-button>
                </div>
            </div>
        </div>
    </div>


    <!-- 订单收费 -->
    <el-dialog
        v-model="orderPayDialogVisible"
        :before-close="cancalPay"
        title="订单收费"
        width="32%"
        align-center
    >
        <div class="pay_content flex_c_col">
            <div class="pay_main_body flex_t_col">
                <!--等待扫码-->
                <div class="pay_screen_con flex_c_col" v-if="isWaitPayLoading && !payLoading && !isPayed">
                    <el-icon class="pay_screen_icon">
                        <Connection />
                    </el-icon>
                    <div class="pay_screen_text">正在等待扫码中，请稍候...</div>
                </div>
                <!--加载圈-->
                <div class="pay_loading_con flex_c_col" v-if="isWaitPayLoading && payLoading && !isPayed">
                    <el-icon class="pay_loading_icon is-loading">
                        <loading />
                    </el-icon>
                    <div class="pay_loading_text">正在等待订单支付，请稍候...</div>
                </div>
                <!-- 订单信息-->
                <div class="pay_order_main" v-if="isWaitPayLoading && !isPayed">
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">患者信息：</div>
                        <div class="pay_info_item_right">{{ patientInfo.name }} {{ patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知' }} {{ patientInfo.age === null ? '--' : patientInfo.age }}岁</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">身份证号：</div>
                        <div class="pay_info_item_right">{{patientInfo.identity===null?"--":patientInfo.identity.substr(0,6) + '********' + patientInfo.identity.substr(14, 20)}}</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">药方单号：</div>
                        <div class="pay_info_item_right">{{ medicalOrder.serialNo }}</div>
                    </div>
                    <div class="pay_info_title">支付信息</div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">医生诊金：</div>
                        <div class="pay_info_item_right">￥{{medicalOrder.docPrice === null ? "0.00" : medicalOrder.docPrice}}</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">加工费用：</div>
                        <div class="pay_info_item_right">￥{{medicalOrder.processingCosts === null || medicalOrder.processingCosts === undefined ? '0.00' : medicalOrder.processingCosts}}</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">订单实付：</div>
                        <div class="pay_info_item_right font_weight font_orange font_28">￥{{ medicalOrder.orderPrice }}</div>
                    </div>
                    <div class="pay_warning_info flex_t_col">
                        <div class="pay_warning_li">*特殊说明：</div>
                        <div class="pay_warning_li">①请仔细核对患者和订单信息，避免错误收费。</div>
                        <div class="pay_warning_li">②请患者打开移动付款码放置扫码盒子上或使用扫码枪扫患者的付款二维码，完成支付。</div>
                    </div>
                </div>
                <!-- 订单结果-->
                <div class="pay_order_main" v-if="!isWaitPayLoading && isPayed">
                    <div class="pay_order_success flex_c_col">
                        <el-icon class="pay_order_success_icon font_green" v-if="payState === 'success'">
                            <SuccessFilled />
                        </el-icon>
                        <el-icon class="pay_order_success_icon font_orange" v-if="payState === 'pending'">
                            <WarningFilled />
                        </el-icon>
                        <el-icon class="pay_order_success_icon font_red" v-if="payState === 'failed'">
                            <CircleCloseFilled />
                        </el-icon>
                        <div class="pay_order_success_text flex_c font_16"><span class="font_gold mrlr10 font_18">{{ patientInfo.name }}</span>的药方订单{{ payResultText }}</div>
                        <div class="pay_order_error_text flex_c font_14" v-if="payState !== 'success' && payErrorMsg"
                             :style="{color: payState === 'pending' ? '#e6a23c' : '#f56c6c', margin: '8px 0'}">{{ payErrorMsg }}</div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">药方单号：</div>
                            <div class="pay_info_item_right font_weight">{{ medicalOrder.serialNo }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">支付单号：</div>
                            <div class="pay_info_item_right font_weight">{{ medicalOrder.serialNo }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between" v-if="successPayed">
                            <div class="pay_info_item_left">支付时间：</div>
                            <div class="pay_info_item_right font_weight">{{ medicalOrder.payTime }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">医生诊金：</div>
                            <div class="pay_info_item_right">￥{{medicalOrder.docPrice === null ? "0.00" : medicalOrder.docPrice}}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">加工费用：</div>
                            <div class="pay_info_item_right">￥{{medicalOrder.processingCosts === null || medicalOrder.processingCosts === undefined ? '0.00' : medicalOrder.processingCosts}}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">订单实付：</div>
                            <div class="pay_info_item_right font_weight font_orange font_28">￥{{ medicalOrder.orderPrice }}</div>
                        </div>
                        <div class="pay_warning_info flex_t_col">
                            <div class="pay_warning_li">*特殊说明：</div>
                            <div class="pay_warning_li" v-if="payState === 'pending'">①支付结果尚未确认，请勿重复扫码，点击「重新查询」确认结果。</div>
                        <div class="pay_warning_li" v-else>①若订单支付失败，请重新扫患者的付款二维码进行扫码支付。</div>
                            <div class="pay_warning_li">②支付完成后，请告知患者可打开“知夏中医健康平台”小程序，查询订单支付结果。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="warning" :loading="querying" v-if="isPayed && payState === 'pending'" @click="requeryPayResult()">重新查询</el-button>
                <el-button type="danger" v-if="isPayed && payState === 'failed'" @click="cancalOrRefreshPay()">刷新重试</el-button>
                <el-button :loading="receiptLoading" v-if="canPrintSqbReceipt" @click="previewPaymentReceipt">预览凭证</el-button>
                <el-button type="success" :loading="receiptLoading" v-if="canPrintSqbReceipt" @click="printPaymentReceipt">打印凭证</el-button>
<!--                <el-button type="primary" v-if="!isPayed" @click="printPayInfo()">打印单据</el-button>-->
                <el-button type="info" @click="cancalPay()">取消</el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog v-model="receiptPreviewVisible" title="门诊收款凭证预览" width="440px" align-center>
        <div class="payment-receipt-print receipt-preview-content">
            <div class="receipt-title">{{ receiptInstitutionName(paymentReceipt.institutionName) }}</div>
            <div class="receipt-name">门诊收款凭证</div>
            <div class="receipt-subtitle">PATIENT PAYMENT RECEIPT</div>
            <div class="receipt-section">
                <div class="receipt-section-title">患者信息</div>
                <div class="receipt-row"><span>患者姓名</span><span>{{ displayReceiptValue(paymentReceipt.patientName) }}</span></div>
                <div class="receipt-row"><span>年龄</span><span>{{ formatReceiptAge(paymentReceipt.patientAge) }}</span></div>
                <div class="receipt-row"><span>性别</span><span>{{ formatReceiptGender(paymentReceipt.patientGender) }}</span></div>
            </div>
            <div class="receipt-section">
                <div class="receipt-section-title">处方摘要</div>
                <div class="receipt-row"><span>处方类型</span><span>{{ formatReceiptPrescriptionType(paymentReceipt.prescriptionType) }}</span></div>
                <div class="receipt-row"><span>剂数</span><span>{{ displayReceiptValue(paymentReceipt.doseCount) }}</span></div>
            </div>
            <div class="receipt-section-title receipt-payment-title">支付信息</div>
            <div class="receipt-amount"><span>实收金额</span><strong>{{ formatReceiptAmount(paymentReceipt.receivedAmount) }}</strong></div>
            <div class="receipt-section">
                <div class="receipt-row"><span>订单号</span><span>{{ displayReceiptValue(paymentReceipt.orderNo) }}</span></div>
                <div class="receipt-row"><span>支付时间</span><span>{{ displayReceiptValue(paymentReceipt.paidAt) }}</span></div>
                <div class="receipt-row"><span>支付方式</span><span>{{ formatReceiptPaymentMethod(paymentReceipt.paymentMethod) }}</span></div>
            </div>
            <div class="receipt-promotion-section" v-if="hasReceiptPromotion()">
                <div class="receipt-promotion-list">
                    <div>
                        <img :src="receiptOfficialAccountQrCode()" @error="handleReceiptPromotionImageError('officialAccount')" alt="知夏集团公众号二维码">
                        <div>打开微信扫一扫，关注【知夏集团】公众号</div>
                    </div>
                </div>
            </div>
            <div class="receipt-section receipt-print-time"><div class="receipt-row"><span>打印时间</span><span>{{ receiptPrintTime }}</span></div></div>
            <div class="receipt-footer">请妥善保管本凭条<br><small>本凭条仅作本次付款核对使用</small></div>
        </div>
        <template #footer>
            <el-button @click="receiptPreviewVisible = false">关闭</el-button>
        </template>
    </el-dialog>

    <div id="paymentReceiptPrintArea" ref="paymentReceiptPrintArea" class="payment-receipt-print">
        <div class="receipt-title">{{ receiptInstitutionName(paymentReceipt.institutionName) }}</div>
        <div class="receipt-name">门诊收款凭证</div>
        <div class="receipt-subtitle">PATIENT PAYMENT RECEIPT</div>
        <div class="receipt-section">
            <div class="receipt-section-title">患者信息</div>
            <div class="receipt-row"><span>患者姓名</span><span>{{ displayReceiptValue(paymentReceipt.patientName) }}</span></div>
            <div class="receipt-row"><span>年龄</span><span>{{ formatReceiptAge(paymentReceipt.patientAge) }}</span></div>
            <div class="receipt-row"><span>性别</span><span>{{ formatReceiptGender(paymentReceipt.patientGender) }}</span></div>
        </div>
        <div class="receipt-section">
            <div class="receipt-section-title">处方摘要</div>
            <div class="receipt-row"><span>处方类型</span><span>{{ formatReceiptPrescriptionType(paymentReceipt.prescriptionType) }}</span></div>
            <div class="receipt-row"><span>剂数</span><span>{{ displayReceiptValue(paymentReceipt.doseCount) }}</span></div>
        </div>
        <div class="receipt-section-title receipt-payment-title">支付信息</div>
        <div class="receipt-amount"><span>实收金额</span><strong>{{ formatReceiptAmount(paymentReceipt.receivedAmount) }}</strong></div>
        <div class="receipt-section">
            <div class="receipt-row"><span>订单号</span><span>{{ displayReceiptValue(paymentReceipt.orderNo) }}</span></div>
            <div class="receipt-row"><span>支付时间</span><span>{{ displayReceiptValue(paymentReceipt.paidAt) }}</span></div>
            <div class="receipt-row"><span>支付方式</span><span>{{ formatReceiptPaymentMethod(paymentReceipt.paymentMethod) }}</span></div>
        </div>
        <div class="receipt-promotion-section" v-if="hasReceiptPromotion()">
            <div class="receipt-promotion-list">
                <div>
                    <img :src="receiptOfficialAccountQrCode()" @error="handleReceiptPromotionImageError('officialAccount')" alt="知夏集团公众号二维码">
                    <div>打开微信扫一扫，关注【知夏集团】公众号</div>
                </div>
            </div>
        </div>
        <div class="receipt-section receipt-print-time"><div class="receipt-row"><span>打印时间</span><span>{{ receiptPrintTime }}</span></div></div>
        <div class="receipt-footer">请妥善保管本凭条<br><small>本凭条仅作本次付款核对使用</small></div>
    </div>
    <el-button ref="paymentReceiptPrintButton" class="receipt-print-trigger" v-print="receiptPrintInfoObj">打印门诊收款凭证</el-button>

</template>

<script>
import orderdetail from "@/assets/scripts/components/orderdetail";

export default orderdetail;
</script>

<style scoped lang="scss">
@import "@/assets/styles/style.scss";

@media screen { .payment-receipt-print, .receipt-print-trigger { display: none; } }
@media print { .payment-receipt-print { display: block !important; } }
.receipt-preview-content { display: block !important; margin: 0 auto; }
.payment-receipt-print { box-sizing: border-box; width: 72mm; padding: 3mm 2.5mm; color: #111; font-family: "Microsoft YaHei", SimSun, sans-serif; font-size: 10pt; line-height: 1.5; }
.receipt-title, .receipt-name, .receipt-subtitle, .receipt-footer, .receipt-barcode-section, .receipt-promotion-title { text-align: center; }
.receipt-title { font-size: 13pt; font-weight: bold; line-height: 1.4; }
.receipt-name { margin-top: 1mm; font-size: 15pt; font-weight: bold; }
.receipt-subtitle { margin: .5mm 0 2mm; padding-bottom: 2mm; border-bottom: 1px solid #111; color: #666; font-size: 8pt; letter-spacing: .7px; }
.receipt-section { padding: 1.8mm 0; border-bottom: 1px dashed #777; }
.receipt-section-title { margin-bottom: 1mm; font-size: 9pt; font-weight: bold; }
.receipt-payment-title { margin-top: 1.8mm; }
.receipt-row { display: flex; justify-content: space-between; gap: 4mm; min-height: 5mm; }
.receipt-row span:last-child { text-align: right; word-break: break-all; font-weight: 500; }
.receipt-amount { display: flex; justify-content: space-between; align-items: center; margin: 1.5mm 0; padding: 2mm; background: #f3f4f6; font-weight: bold; }
.receipt-amount strong { font-size: 13pt; }
.receipt-barcode-section { padding: 2mm 0; border-bottom: 1px dashed #777; font-size: 9pt; font-weight: bold; }
.receipt-barcode-section svg { display: block; width: 60mm; height: 17mm; margin: 1.5mm auto; }
.receipt-order-no { font-size: 9pt; letter-spacing: 1px; }
.receipt-hint, .receipt-footer small, .receipt-promotion-list small { color: #555; font-size: 8pt; font-weight: normal; }
.receipt-promotion-section { padding: 2mm 0; border-bottom: 1px dashed #777; text-align: center; }
.receipt-promotion-title { font-size: 9pt; font-weight: bold; }
.receipt-promotion-list { display: flex; justify-content: center; margin-top: 1.5mm; }
.receipt-promotion-list > div { width: 58mm; font-size: 9pt; font-weight: bold; white-space: nowrap; }
.receipt-promotion-list img { display: block; width: 32mm; height: 32mm; margin: 0 auto 1mm; object-fit: contain; }
.receipt-print-time { border-bottom: 1px solid #111; }
.receipt-footer { padding-top: 2mm; font-size: 9pt; }
</style>
